import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useRef } from 'react';
import { t } from '@/core/localization';
import { Row } from '@/core/styled';
import { Typography } from '@mui/material';
import { MaxLimitNumericField } from './MaxLimitNumericField';
import { PickAllAvailableQuantityChip } from './PickAllAvailableQuantityChip';
const timeSpentOnFocus = 10;
const PickQuantityField = forwardRef(({ availableQuantity, ownerRef, disabled, ...props }, ref) => {
    const inputRef = useRef(null);
    const pickAllAvailableQuantity = useCallback(() => {
        props.onChange(availableQuantity ?? 0);
        inputRef.current?.focus();
        // `onFocus` handles select all text, but sometimes it is not working for the first focus.
        setTimeout(() => inputRef.current?.select(), timeSpentOnFocus);
    }, [availableQuantity, props]);
    const handleOwnerKeyDown = useCallback((event) => {
        if (event.key === '*') {
            pickAllAvailableQuantity();
        }
    }, [pickAllAvailableQuantity]);
    useEffect(() => {
        if (!ownerRef)
            return;
        // Handling eslint error:
        // The ref value 'ownerRef.current' will likely have changed by the time this effect cleanup function runs. If this
        // ref points to a node rendered by React, copy 'ownerRef.current' to a variable inside the effect, and use that
        // variable in the cleanup function. eslint react-hooks/exhaustive-deps
        const ownerElement = ownerRef.current;
        ownerElement?.addEventListener('keydown', handleOwnerKeyDown);
        return () => {
            ownerElement?.removeEventListener('keydown', handleOwnerKeyDown);
        };
    }, [handleOwnerKeyDown, ownerRef]);
    return (_jsxs(Row, { fullWidth: props.fullWidth, alignItems: "center", gap: 3, children: [_jsx(MaxLimitNumericField, { inputRef: inputRef, fullWidth: true, ...props, ref: ref, maxValue: availableQuantity, onFocus: (event) => event.target.select() }), _jsx(Typography, { color: "textMuted", sx: {
                    marginLeft: '.5rem',
                }, children: t('available.label').toLocaleLowerCase() }), _jsx(PickAllAvailableQuantityChip, { tabIndex: -1, availableQuantity: availableQuantity, onClick: pickAllAvailableQuantity })] }));
});
export { PickQuantityField };
